import React from "react";
import articles from "../../data/articles";
import { ArticlePage } from "./Blog1";

const Blog2 = () => <ArticlePage article={articles[1]} />;

export default Blog2;